export default function About() {
  return (
    <section
      id="about"
      className="section-frame"
    >
      <div className="section-card rounded-[2rem] px-6 py-14 sm:px-10 lg:px-14">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr]">
          <div>
            <div className="section-label">About Me</div>
            <h2 className="section-title mt-6 max-w-md text-slate-50">My journey from enterprise support to full-stack development.</h2>
            <p className="section-copy mt-6 max-w-md">
              I did not start in flashy product development. I started by understanding systems, support work, and how production issues affect real users. That foundation helped me move into full-stack development with a more practical mindset.
            </p>
          </div>

          <div className="space-y-6">
            <div className="glass-chip rounded-[1.5rem] p-6" data-aos="fade-right">
              <p className="mono text-xs uppercase tracking-[0.3em] text-sky-300">2002 - August</p>
              <h3 className="mt-3 text-2xl font-semibold text-slate-50">Started at Sopra Steria and learned how production systems really work</h3>
              <p className="mt-3 text-sm leading-7 text-slate-400">
                I began my career working on enterprise systems, production support, and core business workflows. That phase taught me debugging discipline, patience, and the importance of reliable software.
              </p>
            </div>

            <div className="glass-chip rounded-[1.5rem] p-6" data-aos="fade-right">
              <p className="mono text-xs uppercase tracking-[0.3em] text-sky-300">2023 - Now</p>
              <h3 className="mt-3 text-2xl font-semibold text-slate-50">Moved into full-stack development and started building end-to-end products</h3>
              <p className="mt-3 text-sm leading-7 text-slate-400">
                I upskilled in React, Node.js, Express, and PostgreSQL and started building full-stack applications from frontend to database. My projects focus on internal tools, automation, analytics, and solving practical business needs.
              </p>
            </div>

            <div className="glass-chip rounded-[1.5rem] p-6" data-aos="fade-right">
              <p className="mono text-xs uppercase tracking-[0.3em] text-sky-300">Next</p>
              <h3 className="mt-3 text-2xl font-semibold text-slate-50">Now looking for a full-stack role where I can contribute and grow</h3>
              <p className="mt-3 text-sm leading-7 text-slate-400">
                I am looking for opportunities in India where I can work on meaningful products, strengthen my backend and frontend skills, and contribute as part of a strong engineering team.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
